import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  createBid as createBidAPI,
  updateBid as updateBidAPI,
  deleteBid as deleteBidAPI,
  getBidDetails as getBidDetailsAPI,
} from '../../util/api';

// ================ Action Types ================

export const BID_CREATE_REQUEST = 'app/EditBidsPage/BID_CREATE_REQUEST';
export const BID_CREATE_SUCCESS = 'app/EditBidsPage/BID_CREATE_SUCCESS';
export const BID_CREATE_ERROR = 'app/EditBidsPage/BID_CREATE_ERROR';

export const BID_UPDATE_REQUEST = 'app/EditBidsPage/BID_UPDATE_REQUEST';
export const BID_UPDATE_SUCCESS = 'app/EditBidsPage/BID_UPDATE_SUCCESS';
export const BID_UPDATE_ERROR = 'app/EditBidsPage/BID_UPDATE_ERROR';

export const BID_DELETE_REQUEST = 'app/EditBidsPage/BID_DELETE_REQUEST';
export const BID_DELETE_SUCCESS = 'app/EditBidsPage/BID_DELETE_SUCCESS';
export const BID_DELETE_ERROR = 'app/EditBidsPage/BID_DELETE_ERROR';

export const BID_FETCH_REQUEST = 'app/EditBidsPage/BID_FETCH_REQUEST';
export const BID_FETCH_SUCCESS = 'app/EditBidsPage/BID_FETCH_SUCCESS';
export const BID_FETCH_ERROR = 'app/EditBidsPage/BID_FETCH_ERROR';

export const BID_IMAGE_UPLOAD_REQUEST = 'app/EditBidsPage/BID_IMAGE_UPLOAD_REQUEST';
export const BID_IMAGE_UPLOAD_SUCCESS = 'app/EditBidsPage/BID_IMAGE_UPLOAD_SUCCESS';
export const BID_IMAGE_UPLOAD_ERROR = 'app/EditBidsPage/BID_IMAGE_UPLOAD_ERROR';

export const BID_IMAGE_REMOVE_REQUEST = 'app/EditBidsPage/BID_IMAGE_REMOVE_REQUEST';
export const BID_IMAGE_REMOVE_SUCCESS = 'app/EditBidsPage/BID_IMAGE_REMOVE_SUCCESS';
export const BID_IMAGE_REMOVE_ERROR = 'app/EditBidsPage/BID_IMAGE_REMOVE_ERROR';

export const BID_VALIDATION_REQUEST = 'app/EditBidsPage/BID_VALIDATION_REQUEST';
export const BID_VALIDATION_SUCCESS = 'app/EditBidsPage/BID_VALIDATION_SUCCESS';
export const BID_VALIDATION_ERROR = 'app/EditBidsPage/BID_VALIDATION_ERROR';

export const CLEAR_BID_ERRORS = 'app/EditBidsPage/CLEAR_BID_ERRORS';
export const CLEAR_BID_DATA = 'app/EditBidsPage/CLEAR_BID_DATA';

// ================ Reducer ================

const initialState = {
  bid: null,
  bidImages: [],
  validationErrors: {},
  createBidInProgress: false,
  updateBidInProgress: false,
  deleteBidInProgress: false,
  fetchBidInProgress: false,
  imageUploadInProgress: false,
  imageRemoveInProgress: false,
  validationInProgress: false,
  createBidError: null,
  updateBidError: null,
  deleteBidError: null,
  fetchBidError: null,
  imageUploadError: null,
  imageRemoveError: null,
  validationError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case BID_CREATE_REQUEST:
      return {
        ...state,
        createBidInProgress: true,
        createBidError: null,
      };
    case BID_CREATE_SUCCESS:
      return {
        ...state,
        createBidInProgress: false,
        bid: payload.data,
        createBidError: null,
      };
    case BID_CREATE_ERROR:
      return {
        ...state,
        createBidInProgress: false,
        createBidError: payload,
      };

    case BID_UPDATE_REQUEST:
      return {
        ...state,
        updateBidInProgress: true,
        updateBidError: null,
      };
    case BID_UPDATE_SUCCESS:
      return {
        ...state,
        updateBidInProgress: false,
        bid: payload.data,
        updateBidError: null,
      };
    case BID_UPDATE_ERROR:
      return {
        ...state,
        updateBidInProgress: false,
        updateBidError: payload,
      };

    case BID_DELETE_REQUEST:
      return {
        ...state,
        deleteBidInProgress: true,
        deleteBidError: null,
      };
    case BID_DELETE_SUCCESS:
      return {
        ...state,
        deleteBidInProgress: false,
        bid: null,
        bidImages: [],
        deleteBidError: null,
      };
    case BID_DELETE_ERROR:
      return {
        ...state,
        deleteBidInProgress: false,
        deleteBidError: payload,
      };

    case BID_FETCH_REQUEST:
      return {
        ...state,
        fetchBidInProgress: true,
        fetchBidError: null,
      };
    case BID_FETCH_SUCCESS:
      return {
        ...state,
        fetchBidInProgress: false,
        bid: payload.data,
        bidImages: payload.included || [],
        fetchBidError: null,
      };
    case BID_FETCH_ERROR:
      return {
        ...state,
        fetchBidInProgress: false,
        fetchBidError: payload,
      };

    case BID_IMAGE_UPLOAD_REQUEST:
      return {
        ...state,
        imageUploadInProgress: true,
        imageUploadError: null,
      };
    case BID_IMAGE_UPLOAD_SUCCESS:
      return {
        ...state,
        imageUploadInProgress: false,
        bidImages: [...state.bidImages, payload.data],
        imageUploadError: null,
      };
    case BID_IMAGE_UPLOAD_ERROR:
      return {
        ...state,
        imageUploadInProgress: false,
        imageUploadError: payload,
      };

    case BID_IMAGE_REMOVE_REQUEST:
      return {
        ...state,
        imageRemoveInProgress: true,
        imageRemoveError: null,
      };
    case BID_IMAGE_REMOVE_SUCCESS:
      return {
        ...state,
        imageRemoveInProgress: false,
        bidImages: state.bidImages.filter(img => img.id !== payload.id),
        imageRemoveError: null,
      };
    case BID_IMAGE_REMOVE_ERROR:
      return {
        ...state,
        imageRemoveInProgress: false,
        imageRemoveError: payload,
      };

    case BID_VALIDATION_REQUEST:
      return {
        ...state,
        validationInProgress: true,
        validationError: null,
      };
    case BID_VALIDATION_SUCCESS:
      return {
        ...state,
        validationInProgress: false,
        validationErrors: payload.validationErrors || {},
        validationError: null,
      };
    case BID_VALIDATION_ERROR:
      return {
        ...state,
        validationInProgress: false,
        validationError: payload,
      };

    case CLEAR_BID_ERRORS:
      return {
        ...state,
        createBidError: null,
        updateBidError: null,
        deleteBidError: null,
        fetchBidError: null,
        imageUploadError: null,
        imageRemoveError: null,
        validationError: null,
        validationErrors: {},
      };

    case CLEAR_BID_DATA:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}

// ================ Selectors ================

export const getBid = state => state.EditBidsPage.bid;
export const getBidImages = state => state.EditBidsPage.bidImages;
export const getValidationErrors = state => state.EditBidsPage.validationErrors;

export const getCreateBidInProgress = state => state.EditBidsPage.createBidInProgress;
export const getUpdateBidInProgress = state => state.EditBidsPage.updateBidInProgress;
export const getDeleteBidInProgress = state => state.EditBidsPage.deleteBidInProgress;
export const getFetchBidInProgress = state => state.EditBidsPage.fetchBidInProgress;
export const getImageUploadInProgress = state => state.EditBidsPage.imageUploadInProgress;
export const getImageRemoveInProgress = state => state.EditBidsPage.imageRemoveInProgress;
export const getValidationInProgress = state => state.EditBidsPage.validationInProgress;

export const getCreateBidError = state => state.EditBidsPage.createBidError;
export const getUpdateBidError = state => state.EditBidsPage.updateBidError;
export const getDeleteBidError = state => state.EditBidsPage.deleteBidError;
export const getFetchBidError = state => state.EditBidsPage.fetchBidError;
export const getImageUploadError = state => state.EditBidsPage.imageUploadError;
export const getImageRemoveError = state => state.EditBidsPage.imageRemoveError;
export const getValidationError = state => state.EditBidsPage.validationError;

// ================ Action Creators ================

export const createBidRequest = () => ({
  type: BID_CREATE_REQUEST,
});

export const createBidSuccess = response => ({
  type: BID_CREATE_SUCCESS,
  payload: response,
});

export const createBidError = error => ({
  type: BID_CREATE_ERROR,
  payload: error,
});

export const updateBidRequest = () => ({
  type: BID_UPDATE_REQUEST,
});

export const updateBidSuccess = response => ({
  type: BID_UPDATE_SUCCESS,
  payload: response,
});

export const updateBidError = error => ({
  type: BID_UPDATE_ERROR,
  payload: error,
});

export const deleteBidRequest = () => ({
  type: BID_DELETE_REQUEST,
});

export const deleteBidSuccess = response => ({
  type: BID_DELETE_SUCCESS,
  payload: response,
});

export const deleteBidError = error => ({
  type: BID_DELETE_ERROR,
  payload: error,
});

export const fetchBidRequest = () => ({
  type: BID_FETCH_REQUEST,
});

export const fetchBidSuccess = response => ({
  type: BID_FETCH_SUCCESS,
  payload: response,
});

export const fetchBidError = error => ({
  type: BID_FETCH_ERROR,
  payload: error,
});

export const uploadBidImageRequest = () => ({
  type: BID_IMAGE_UPLOAD_REQUEST,
});

export const uploadBidImageSuccess = response => ({
  type: BID_IMAGE_UPLOAD_SUCCESS,
  payload: response,
});

export const uploadBidImageError = error => ({
  type: BID_IMAGE_UPLOAD_ERROR,
  payload: error,
});

export const removeBidImageRequest = () => ({
  type: BID_IMAGE_REMOVE_REQUEST,
});

export const removeBidImageSuccess = response => ({
  type: BID_IMAGE_REMOVE_SUCCESS,
  payload: response,
});

export const removeBidImageError = error => ({
  type: BID_IMAGE_REMOVE_ERROR,
  payload: error,
});

export const validateBidRequest = () => ({
  type: BID_VALIDATION_REQUEST,
});

export const validateBidSuccess = response => ({
  type: BID_VALIDATION_SUCCESS,
  payload: response,
});

export const validateBidError = error => ({
  type: BID_VALIDATION_ERROR,
  payload: error,
});

export const clearBidErrors = () => ({
  type: CLEAR_BID_ERRORS,
});

export const clearBidData = () => ({
  type: CLEAR_BID_DATA,
});

// ================ Thunks ================

export const createBid = bidData => (dispatch, getState, sdk) => {
  dispatch(createBidRequest());

  return createBidAPI(bidData)
    .then(response => {
      const normalized = { data: response?.bid || response?.data?.bid || response };
      if (!normalized?.data?.id) {
        throw new Error('Bid creation did not return a created bid id.');
      }
      dispatch(createBidSuccess(normalized));
      return normalized;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(createBidError(error));
      throw error;
    });
};

export const updateBid = (bidId, bidData) => (dispatch, getState, sdk) => {
  dispatch(updateBidRequest());

  const currentUserId = getState()?.user?.currentUser?.id?.uuid;
  const updatePayload = {
    user_id: currentUserId,
    min_offer: bidData.minPrice,
    max_offer: bidData.maxPrice,
    ticket_type: bidData.ticketType,
    details: bidData.description,
  };

  return updateBidAPI(bidId, updatePayload)
    .then(response => {
      const normalized = { data: response?.bid || response?.data?.bid || response };
      dispatch(updateBidSuccess(normalized));
      return normalized;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(updateBidError(error));
      throw error;
    });
};

export const deleteBid = bidId => (dispatch, getState, sdk) => {
  dispatch(deleteBidRequest());

  const currentUserId = getState()?.user?.currentUser?.id?.uuid;

  return deleteBidAPI(bidId, { user_id: currentUserId })
    .then(response => {
      dispatch(deleteBidSuccess(response));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(deleteBidError(error));
      throw error;
    });
};

export const fetchBid = bidId => (dispatch, getState, sdk) => {
  dispatch(fetchBidRequest());

  return getBidDetailsAPI(bidId)
    .then(response => {
      const normalized = { data: response?.bid || response?.data?.bid || response };
      dispatch(fetchBidSuccess(normalized));
      return normalized;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(fetchBidError(error));
      throw error;
    });
};

export const uploadBidImage = (bidId, imageFile) => (dispatch, getState, sdk) => {
  dispatch(uploadBidImageRequest());

  const imageParams = {
    data: {
      type: 'image',
      attributes: {
        file: imageFile,
        bidId: bidId,
      },
    },
  };

  return sdk.images
    .upload(imageParams)
    .then(response => {
      dispatch(uploadBidImageSuccess(response));
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(uploadBidImageError(error));
      throw error;
    });
};

export const removeBidImage = imageId => (dispatch, getState, sdk) => {
  dispatch(removeBidImageRequest());

  return sdk.images
    .delete({ id: imageId })
    .then(response => {
      dispatch(removeBidImageSuccess({ id: imageId }));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(removeBidImageError(error));
      throw error;
    });
};

export const validateBid = bidData => (dispatch, getState, sdk) => {
  dispatch(validateBidRequest());

  const validationParams = {
    data: {
      type: 'bidValidation',
      attributes: bidData,
    },
  };

  return sdk.bids
    .validate(validationParams)
    .then(response => {
      dispatch(validateBidSuccess(response));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(validateBidError(error));
      throw error;
    });
};

export const publishBid = bidId => (dispatch, getState, sdk) => {
  dispatch(updateBidRequest());

  const bidParams = {
    data: {
      type: 'bid',
      id: bidId,
      attributes: {
        status: 'published',
      },
    },
  };

  return sdk.bids
    .update(bidParams)
    .then(response => {
      dispatch(updateBidSuccess(response));
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(updateBidError(error));
      throw error;
    });
};
